import { TrackEventParams } from '@datapunt/matomo-tracker-react/lib/types';
import {
  TILES,
  TileCategoriesEnum
} from '../components/DrawerWrapper/tileSummaries';
import { TilesInterface } from '../components/Grid/tiles';
import { MatomoAction, MatomoCategory } from '../Constants';
import { ILanguages } from '../handlers/TranslationsHandler';

export const autoFillSpecialTiles = (
  isInSpecialMode: boolean,
  mainTiles: TilesInterface[],
  setMainTiles: (value: React.SetStateAction<TilesInterface[]>) => void
) => {
  if (isInSpecialMode) {
    const noTilesFilled = mainTiles.filter(mt => mt.name).length;

    if (noTilesFilled < mainTiles.length) {
      const selectedAutofillTiles = mainTiles.filter(selectedTile =>
        TILES.find(tile => tile.autofillTile && tile.name === selectedTile.name)
      );

      if (noTilesFilled - selectedAutofillTiles.length >= 3) {
        const remainingAutoFillTiles = TILES.filter(
          smt =>
            smt.autofillTile &&
            !selectedAutofillTiles.find(sst => sst.name === smt.name)
        );

        const remainingTilesIterator = remainingAutoFillTiles.values();

        const newTiles = mainTiles.map(mt => {
          if (!mt.name) {
            const nextTile = remainingTilesIterator.next();
            if (!nextTile.done) {
              return {
                ...mt,
                name: nextTile.value.name
              };
            }
          }
          return { ...mt };
        });

        setMainTiles([...newTiles]);
      }
    }
  }
};

export const swapTiles = (
  tiles: TilesInterface[],
  draggedTile: string,
  draggedOverTile: string
) => {
  return tiles.map((tile: TilesInterface) => {
    if (tile.name === draggedTile) {
      return tiles.find(tile => tile.name === draggedOverTile);
    } else if (tile.name === draggedOverTile) {
      return tiles.find(tile => tile.name === draggedTile);
    }
    return tile;
  }) as TilesInterface[];
};

export const handleAddTile = (
  tileName: string,
  tiles: Array<TilesInterface>,
  setTiles: React.Dispatch<React.SetStateAction<TilesInterface[]>>,
  currentTileKey: string | undefined,
  setVisibleDrawer: React.Dispatch<React.SetStateAction<boolean>>,
  trackEvent: (params: TrackEventParams) => void | undefined
) => {
  if (tiles.find(tileItem => tileItem.name === tileName)) {
    return;
  }

  setTiles(existingTiles =>
    existingTiles.map(existingTile => {
      if (existingTile.key === currentTileKey) {
        let trackEvenAction = MatomoAction.NewTileAdded;
        let trackEventName = tileName;
        if (existingTile.name) {
          trackEvenAction = MatomoAction.TileChanged;
          trackEventName = `${existingTile.name} -> ${tileName}`;
        }
        trackEvent({
          category: MatomoCategory.Tiles,
          action: trackEvenAction,
          name: trackEventName
        });
        return { ...existingTile, name: tileName };
      }
      return existingTile;
    })
  );

  setVisibleDrawer(false);
};

export const sortedTileCategories = (isInFinancesMode: boolean) =>
  Object.values(TileCategoriesEnum)
    .filter(cat => isNaN((cat as unknown) as number))
    .sort((a, b) => (a as string).localeCompare(b as string))
    .map(category => category)
    .reduce((categories: string[], category: string) => {
      const shouldInclude =
        category !== TileCategoriesEnum.Finanzen ||
        (category === TileCategoriesEnum.Finanzen && isInFinancesMode);

      shouldInclude && categories.push(category);
      return categories;
    }, []);

export const filterTilesByCategory = (
  category: string,
  translate: (t: string | ILanguages) => any
) =>
  [...TILES]
    .filter(ft => ft.category === TileCategoriesEnum[category])
    .sort((a, b) => translate(a.title).localeCompare(translate(b.title)))
    .map(tile => tile);
